import PropTypes from "prop-types";
import { createPortal } from "react-dom";

export default function TooltipPortal({ text, position, visible }) {
  if (!visible || !position || !text) return null;

  return createPortal(
    <div
      className="pointer-events-none fixed z-[60] max-w-[min(320px,90vw)] -translate-y-1/2 truncate rounded-full bg-black px-3 py-1 text-xs font-semibold text-white shadow-lg"
      style={{ left: position.left, top: position.top }}
      role="tooltip"
    >
      {text}
    </div>,
    document.body,
  );
}

TooltipPortal.propTypes = {
  text: PropTypes.string,
  position: PropTypes.shape({
    left: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired,
  }),
  visible: PropTypes.bool,
};
